<template>
  <div
    :id="`${zone.zoneID}_${zone.zoneName}`"
    style="position:absolute;
      background-repeat: no-repeat;
      background-size: cover;
    "
    :style="{
      backgroundColor: zone.color,
      color: zone.textColor,
      fontSize: fontSize,
      top: top,
      right: right,
      width: width,
      height: height,
      backgroundImage: zone.background ? `url('${zone.background}')` : null,
    }"
  >
    <!--small v-if="zone.zoneID === '2'" style="color: blue">{{zone}}</small-->
    <div v-if="showInfo" style="position:absolute; color: white;background-color:#CCCCCC80;padding: 5px 10px;">{{zone.zoneID}} - {{zone.zoneName}}</div>
    <custom-carousel 
      v-if="contents"
      :contents="contents"
      :onEnd="handleCarouselEnd"
      :zone="zone.zoneName"
      :backgroundImage="background"
      :lmu="lmu"
    />
  </div>
</template>
<script>
import { parseString } from 'xml2js'
import CustomCarousel from '../CustomCarousel'
export default {
  components: {
    CustomCarousel,
  },
  props: {
    showInfo: {
      type: Boolean,
      default: false,
    },
    fontSize: {
      type: String,
      required: true,
    },
    top: {
      type: String,
      required: true,
    },
    right: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      required: true,
    },
    originalWidth: {
      type: [String, Number],
      required: true,
    },
    originalHeight: {
      type: [String, Number],
      required: true,
    },
    zone: {
      type: Object,
      requried: true,
    },
    scaleFactor: {
      type: Number,
      required: true,
    },
    speedFactor: {
      type: Number,
      default: 1,
    },

    onHideZone: {
      type: Function,
      required: true
    },
    onShowZone: {
      type: Function,
      required: true
    },
    onSendZoneMessage: {
      type: Function,
      required: true,
    },
    zoneMessage: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    actualState: null,
    background: null,
    states: null,
    contents: [],
    lmu: null,
  }),
  computed: {
    forceScale () {
      return 0.42
    },
  },
  watch: {
    'item.XML' () {
      this.handleGetItems()
    },
    xml () {
      this.handleGetItems()
    },
    speedFactor () {
      this.handleGetItems()
    },
    zoneMessage () {
      this.handleChangeBackgroundByZoneMessage()
    },
  },
  mounted () {
    this.init()
    this.handleGetItems()
  },
  methods: {
    init () {
      if (this.zone.type === 'interactive') {
        this.prepareStates()
      } else {
        this.prepareNormal ()
      }
    },
    async prepareNormal () {
      /*
      if (this.zone.zoneName === 'BANNER LATERAL') {
        console.log('aaaa2', this.zone)
      }
      */
      const contents = []
      if (this.zone.zoneType === 'Clock') {
        contents.push({ content: this.prepareClock(), duration: 10000, type: 'Clock' })
        //this.contents.push({ content: this.prepareClock(), duration: 10000, type: 'Clock' })
        //return
      }
      if (this.zone.rss) {
        for (const rss of this.zone.rss) {
          if (rss.url) {
            contents.push(...await new Promise((resolve) => this.getContentsByXML(rss.url, (err, rows) => {
              if (err) resolve([])
              else resolve(rows)
            })))
            /*
            this.contents.push(...await new Promise((resolve) => this.getContentsByXML(rss.url, (err, rows) => {
              if (err) resolve([])
              else resolve(rows)
            })))
            */
          }
        }
        //return
      }
      if (this.zone.html) {
        for (const html of this.zone.html) {
          if (html.url) {
            //if (this.zone.zoneName === 'BANNER LATERAL') { alert(html.timeOnString) }
            contents.push(this.prepareMediaContent ('html', html.url, html.name, html.timeOnScreen ? this.prepareDurationWidhtSpeedFactor(html.timeOnScreen | 0) : 20))
            //this.contents.push(this.prepareMediaContent ('html', html.url, html.name, html.timeOnScreen ? this.prepareDurationWidhtSpeedFactor(html.timeOnScreen | 0) : 20))
          }
        }
        //return
      }
      this.contents = contents
      if (this.zone.zoneName !== 'CENTRAL ACTIVIDADES') return
    },
    async prepareStates () {
      this.states = {}
      const s = this.zone.states
      //if (this.zone.zoneID === '2') console.log('ddddhhhh', s)
      for (const t of s.transitions) {
        const state = s.items.filter(x => x.name === t.source).shift()
        let contents = []
        if (state.rss) {
          contents.push(...await new Promise((resolve) => this.getContentsByXML(state.rss, (err, rows) => {
            if (err) resolve([])
            else resolve(rows)
          })))
          if (contents.length === 1) {
            contents.unshift({ content: '<img src="https://www.dviewcontent.com/asset/clean.png" width="100%" height="100%">', duration: 0.5, type: "png" })
            contents.push({ content: '<img src="https://www.dviewcontent.com/asset/clean.png" width="100%" height="100%">', duration: 0.5, type: "png" })
          }
        } else if (t.userEvent && t.userEvent.name === 'zoneMessage') {
          let duration = 1000000
          contents.push({ content: '<img src="https://www.dviewcontent.com/asset/clean.png" width="100%" height="100%">', duration, type: "png" })
        } else {
          //alert(this.zone.zoneID + ' ' + this.zone.name)
          //console.log('TODO', state.name, t.userEvent.name, state)
          //let duration = t.userEvent && t.userEvent.name === 'timeout' ? (t.userEvent.parameter) | 0 : 15
          let duration = t.userEvent && t.userEvent.name === 'timeout' ? (t.userEvent.parameter) | 0 : 0.5
          //alert(duration)
          contents.push({ content: '<img src="https://www.dviewcontent.com/asset/clean.png" width="100%" height="100%">', duration, type: "png" })
        }
      //console.log(this.zone.zoneName)
        /*
        if (contents && contents.filter(x => x.content.indexOf('https://www.dviewcontent.com/asset/clean.png') > 0).length > 0 && contents.filter(x => x.content.indexOf('https://www.dviewcontent.com/asset/clean.png') < 0).length > 0  ) {
          //console.log('aaaaappppp', contents)
          contents = contents.filter(x => x.content.indexOf('https://www.dviewcontent.com/asset/clean.png') < 0)
          //console.log('aaaaappppp', contents)
        }*/
      //if (this.zone.zoneName === 'PARRILLA') console.log('ddd', contents)

        this.states[t.source] = {
          target: t.target,
          contents,
          state,
        }
      }

      //if (this.zone.zoneID === '2') console.log('ddddhhhh-----', s)
      this.nextState(s.initialState)


    },
    handleChangeBackgroundByZoneMessage () {
      if (!this.zoneMessage || !this.zone.states || !this.zone.states.items || this.zone.states.length === 0) return
      if (!this.zone.states.transitions) return

      //console.log('jhm', this.zoneMessage, typeof this.zone.states, this.zone.states)

      for (const t of this.zone.states.transitions.filter(x => x.userEvent && x.userEvent.name === 'zoneMessage' && x.userEvent.parameter === this.zoneMessage)) {
        const aux = this.zone.states.items.filter(x => x.name === t.target).shift()
        if (aux) this.background = aux.background
        //console.log('jhm', aux.background, t.target, this.zone.states.items)
      }
        /*
      for (const t of this.zone.states.transitions) {
        console.log('change', t)
        const state = s.items.filter(x => x.name === t.source).shift()
        const contents = []
        if (state.rss) {
          contents.push(...await new Promise((resolve) => this.getContentsByXML(state.rss, (err, rows) => {
            if (err) resolve([])
            else resolve(rows)
          })))
        } else if (t.userEvent && t.userEvent.name === 'zoneMessage') {
          console.log('TODO', state.name, t.userEvent.name, state)
          let duration = 1000000
          contents.push({ content: '<img src="https://www.dviewcontent.com/asset/clean.png" width="100%" height="100%">', duration, type: "png" })
        } else {
          //console.log('TODO', state.name, t.userEvent.name, state)
          let duration = t.userEvent && t.userEvent.name === 'timeout' ? (t.userEvent.parameter) | 0 : 15
          contents.push({ content: '<img src="https://www.dviewcontent.com/asset/clean.png" width="100%" height="100%">', duration, type: "png" })
        }

        this.states[t.source] = {
          target: t.target,
          contents,
          state,
        }
      }
        */
      //console.log('change ssss', s)
      //console.log('change background', this.zoneMessage)
    },
    nextState (v) {
      if (this.actualState && this.states[this.actualState].state.cmdExit) {
        for (const cmd of this.states[this.actualState].state.cmdExit) {
          if (cmd.name === 'HideZone') {
            for (const p of cmd.parameters.filter(x => x.name === 'zone' && x.value)) {
              this.onHideZone(p.value)
            }
            continue
          }
          if (cmd.name === 'ShowZone') {
            for (const p of cmd.parameters.filter(x => x.name === 'zone' && x.value)) {
              this.onShowZone(p.value)
            }
            continue
          }
          if (cmd.name === 'SendZoneMessage') {
            for (const p of cmd.parameters.filter(x => x.name === 'zoneMessage' && x.value)) {
              this.onSendZoneMessage(p.value)
            }
            continue
          }
        }
      }
      this.actualState = v
      this.contents = this.states[v].contents
      //if (this.zone.zoneID === '2') console.log('dddcontent', this.contents)
      if (this.states[v].state.cmd) {
        for (const cmd of this.states[v].state.cmd) {
          if (cmd.name === 'HideZone') {
            for (const p of cmd.parameters.filter(x => x.name === 'zone' && x.value)) {
              this.onHideZone(p.value)
            }
            continue
          }
          if (cmd.name === 'ShowZone') {
            for (const p of cmd.parameters.filter(x => x.name === 'zone' && x.value)) {
              this.onShowZone(p.value)
            }
            continue
          }
          if (cmd.name === 'SendZoneMessage') {
            for (const p of cmd.parameters.filter(x => x.name === 'zoneMessage' && x.value)) {
              this.onSendZoneMessage(p.value)
            }
            continue
          }
        }
      }
      const background = this.states[v].state ? this.states[v].state.background : this.zone.background
      if (background) this.background = background
    },
    handleCarouselEnd () {
      this.lmu = new Date().toISOString()
      if (this.actualState && this.states) {
        this.nextState(this.states[this.actualState].target)
        return
      }
    },
    getContentsByXML (v, callback) {
      fetch(v)
        .then(response => response.text())
        .then(data => {
          const result = []
          if (!data) return callback(null, result)
          parseString(data, (err, rows) => {
            if (!rows || !rows.rss || !rows.rss.channel) return callback(null, result)
            const channel = rows.rss.channel.shift()
            if (!channel || !channel.item) return callback(null, result)
            result.push(...channel.item.map(item => {
              if (item['media:content']) {
                const { url, type, description, duration } = item['media:content'].shift()['$']
                return this.prepareMediaContent(type, url, description, duration)
              } else if (item.description) {
                let time = ((item.description.length /200) | 0)
                time = (time ? time : 1) * 25
                return this.prepareMediaContent('message', null, item.description, time)
              }
            }))
            return callback(null, result)
          })
        })
        .catch(err => callback(err)) 
    },
    prepareClock () {
      const event = new Date()
      const options = !this.zone.displayTime ? {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      } : {
        hour: 'numeric', hour12: false, minute: 'numeric' 
      }

      const text = !this.zone.displayTime ? event.toLocaleDateString('es-ES', options) : event.toLocaleDateString('es-ES', options).split(',').pop().split(':').map(item => `0${item.replace(' ', '')}`.slice(-2)).join(':')
      return {
        text,
        w: this.width.replace('px', '') | 0,
        h: this.height.replace('px', '') | 0,
      }
      /*
      //const sw = text.length * 5
      const sw = (this.width.replace('px', '') | 0) / text.length
      const sh = (this.height.replace('px', '') | 0) * 7
      console.log(sw, sh)
      return `<div class="module" style="line-height:1;font-size: ${sw}px;height:${this.height} !important;background-color: ${this.backgroundColor};color:${this.color ? this.color : 'red'};"><h2>${text}</h2></div>`
*/
/*
        return `<custom-text :value="
${
event.toLocaleDateString('es-ES', options)}" />`
        return `<div class="module" style="line-height:1;font-size: calc((75vw - 4.5rem) / 7);height:${this.height} !important;background-color: ${this.backgroundColor};font-size:14px;color:${this.color ? this.color : 'red'};">


<svg viewBox="0 0 56 ${this.height.replace('px','')}">
  <text x="0" y="0">
${event.toLocaleDateString('es-ES', options)}
</text>
</svg>
</div>`
        return `<div style="padding-top:5px;height:${this.height} !important;background-color: ${this.backgroundColor};font-size:10px;color:${this.color ? this.color : 'red'};">
                <b>${event.toLocaleDateString('es-ES', options)}</b>
              </div>`
      } else {
        const event = new Date()
        const options = {
          hour: 'numeric', hour12: false, minute: 'numeric' 
        }
        let time = event.toLocaleDateString('es-ES', options).split(',').pop()
        time = time ? time.split(':').map(item => `0${item.replace(' ', '')}`.slice(-2)).join(':') : null
        
        return `<div class="module" style="line-height:1;font-size: calc((75vw - 4.5rem) / 7);height:${this.height} !important;background-color: ${this.backgroundColor};font-size:14px;color:${this.color ? this.color : 'red'};"><h2>${time}</h2></div>`
        //return `<div style="line-height:1;font-size: calc((75vw - 4.5rem) / 7);height:${this.height} !important;background-color: ${this.backgroundColor};font-size:14px;color:${this.color ? this.color : 'red'};">${time}</div>`

        /*return `<div style="line-height:1;font-size:${this.height} !important;height:${this.height} !important;background-color: ${this.backgroundColor};font-size:14px;color:${this.color ? this.color : 'red'};">
              ${time}
              </div>`*/
        
          /*
        return `<div style="padding-top:6px;height:${this.height} !important;background-color: ${this.backgroundColor};font-size:14px;color:${this.color ? this.color : 'red'};">
                <b>${time}</b>
              </div>`
      }
              */
    },
    prepareMessage (v, duration) {
      return `<div class="message-preview" style="height:${this.height} !important;background-color: ${this.zone.color};font-size:${this.height};color:${this.zone.textColor};line-height:${this.height}">
              <span class="p-preview" style="animation-duration: ${duration}s;font-size:${this.height};color:${this.zone.textColor};">${v}</span>
              </div>`
    },
    prepareDurationWidhtSpeedFactor (v) {
      const aux = v / this.speedFactor
      return aux < 1 ? 1 : aux | 0
    },
    prepareMediaContent (type, url, description, duration) {
      if (!duration || duration.length === 0) duration = 1
      const content = type === 'message'? this.prepareMessage(description, duration) : type === 'html' ? `<iframe class="frame" scrolling="no" src="${url}" style="z-index:100;border:0;width:${this.originalWidth}px;height:${this.originalHeight}px;-ms-zoom: ${this.forceScale || this.scaleFactor};-moz-transform: scale(${this.forceScale || this.scaleFactor});-moz-transform-origin: 0 0;-o-transform: scale(${this.forceScale || this.scaleFactor});-o-transform-origin: 0 0;-webkit-transform: scale(${this.forceScale || this.scaleFactor});-webkit-transform-origin: 0 0;" />`
        : type === 'mp4' ? 
          `<video src="${url}" width="100%" height="100%" loop autoplay="autoplay" muted defaultmuted playsinline onloadstart="this.playbackRate = ${1 * this.speedFactor};" />`
        : `<img src="${url}" width="100%" height="100%">`
      //console.log(type, url, duration, this.prepareDurationWidhtSpeedFactor(duration))
      return {
        content,
        duration: this.prepareDurationWidhtSpeedFactor(duration),
        type
      }
    },
    async handleGetItems () {
      try {
        const contents = []
        if (this.zone.Type === 'Clock') {
          contents.push({ content: this.prepareClock(), duration: 10000, type: 'Clock' })
        } else {
          if (!this.xmls || this.xmls.length === 0) return
          for (const xml of this.xmls) {
            if (xml.indexOf('.xml') < 0) {
              const params = xml.split('https')
              if (params.length === 2) {
                contents.push(this.prepareMediaContent ('html', `https${params[1]}`, null, params[0]))
              } else {
                contents.push(this.prepareMediaContent ('html', `https${params[0]}`, null, 10))
              }
              continue
            }
            /*
            //const data = await new Promise((resolve, reject) => axios.get(xml, { headers: {"Authorization" : `Bearer ${tokenStr}`} })
            const data = await new Promise((resolve, reject) => axios.get(xml, { headers: {} })
              .then (response => {
                resolve(response.data)
              })
              .catch (error => {
               reject(error)
              }))*/
            const data = await new Promise((resolve) => fetch(xml)
              .then(response => response.text())
              .then(data => resolve(data))
              .catch(() => resolve(null))
            )
            if (data) {
              const results = await new Promise((resolve, reject) => parseString(data, (err, results) => {
                if (err) reject(err)
                else resolve(results)
              }))

              if (!results || !results.rss || !results.rss.channel) continue
              const channel = results.rss.channel.shift()
              if (!channel || !channel.item) continue
              contents.push(...channel.item.map(item => {
                if (item['media:content']) {
                  const { url, type, description, duration } = item['media:content'].shift()['$']
                  return this.prepareMediaContent(type, url, description, duration)
                } else if (item.description) {
                  let time = ((item.description.length /200) | 0)
                  time = (time ? time : 1) * 25
                  return this.prepareMediaContent('message', null, item.description, time)
                }
              }))
            }
          }
        } // else isClock
        this.contents = contents
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>
<style>
.module h2 {
  font-size: 1em;
  container-name: sidebar
}

@container sidebar (min-width: 700px) {
  .module h2 {
    font-size: 2em;
  }
}
</style>


